<template>
  <form id="clinical-search-form" class="vue-app">
    <div class="form-row">
      <div class="col-12 col-lg-6">
        <strong class="h5 d-block">Search By:</strong>
        <div class="form-group">
          <input id="keyword" type="text" class="form-control" placeholder="Keyword"
              v-model="form.keyword" ref="keyword">
        </div>
        <div class="form-group">
          <multiselect
            id="search-cancer-type"
            ref="search_cancer_type"
            v-model="form.cancer_type"
            :options="cancer_types"
            placeholder="Cancer Types:"
            selectLabel="Press enter or click to select"
            deselectLabel="Press enter or click to remove"
            label="text"
            track-by="id"
            :maxHeight="dropdownHeight"
            @open="onMultiselectOpen"
            @close="onMultiselectClose"
          >
          </multiselect>
        </div>
        <div class="form-group">
          <multiselect
            id="search-therapy-line"
            ref="search_therapy_line"
            v-model="form.therapy_line"
            :options="therapy_lines"
            :multiple="true"
            placeholder="Line of Therapy:"
            :close-on-select="false"
            :clear-on-select="true"
            selectLabel="Press enter or click to select"
            deselectLabel="Press enter or click to remove"
            label="text"
            track-by="id"
            :maxHeight="dropdownHeight"
            @open="onMultiselectOpen"
            @close="onMultiselectClose"
          >
          </multiselect>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <h5>Find It Near Me:</h5>
        <div class="form-row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <input id="postal_code" type="text" class="form-control"
                  placeholder="City or ZIP Code" v-model="form.postal_code" ref="postal_code" :disabled="form.using_geolocation">
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <button type="button" @click.prevent="getUserLocation()"
              class="btn btn-primary location-btn w-100"
              v-bind:class="{'using-geolocation': form.using_geolocation}">Detect My Location</button>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <multiselect
                id="search-county"
                ref="search_county"
                v-model="form.county"
                :options="counties"
                :multiple="true"
                placeholder="County:"
                :close-on-select="false"
                :clear-on-select="true"
                selectLabel="Press enter or click to select"
                deselectLabel="Press enter or click to remove"
                label="text"
                track-by="id"
                :maxHeight="dropdownHeight"
                @open="onMultiselectOpen"
                @close="onMultiselectClose"
              >
              </multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <multiselect
                id="search-radius"
                ref="search_radius"
                v-model="form.radius"
                :options="radii"
                :close-on-select="true"
                :search="false"
                label="text"
                track-by="id"
                :maxHeight="dropdownHeight"
                @open="onMultiselectOpen"
                @close="onMultiselectClose"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="form-group">
          <multiselect
            id="search-location"
            ref="search_location"
            v-model="form.location_id"
            :options="locations"
            :multiple="true"
            placeholder="Specific FCS Location:"
            :close-on-select="false"
            :clear-on-select="true"
            selectLabel="Press enter or click to select"
            deselectLabel="Press enter or click to remove"
            label="text"
            track-by="id"
            :maxHeight="dropdownHeight"
            @open="onMultiselectOpen"
            @close="onMultiselectClose"
          >
          </multiselect>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-12 d-flex justify-content-start">
        <strong class="h5 d-block">Status:</strong>
        <div class="form-check form-check-inline mx-2 pb-1">
          <input class="form-check-input" type="radio" name="inlineRadioOptions" id="open_accrual"
              value="open-to-accural" v-model="form.trial_status" ref="open_accrual">
          <label class="form-check-label" for="open_accrual">Open to Accrual</label>
          <input class="form-check-input ml-1" type="radio" name="inlineRadioOptions" id="hold_open"
              value="open-on-hold" v-model="form.trial_status" ref="hold_open">
          <label class="form-check-label" for="hold_open">Hold on Open</label>
        </div>
      </div>
    </div>
    <div class="form-row">
        <button type="submit" @click.prevent="searchTrials()" class="btn btn-primary mr-1">Search</button>
        <button type="button" @click.prevent="resetForm()" class="btn btn-dark">Reset Form</button>
    </div>  </form>
</template>
<script>
import { Loader } from '@googlemaps/js-api-loader';
import ApiCalls from "../api/apiServices";
const MULTISELECT_DELIMITER = ',';
const MUTLISELECT_FIELDS = ['location_id', 'therapy_line', 'county'];

let geocoder;

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#clinical-search-form')) {
    const loader = new Loader({
      apiKey: window.gmapi,
      version: 'weekly',
      libraries: ['geometry']
    });
    loader.load().then(() => {
      geocoder = new google.maps.Geocoder();
    });
  }
})


export default {
  data() {
    let params = new URLSearchParams(window.location.search);
    let form = {};
    let radii = this.getRadiusOptions();
    // set simple defaults from query params
    ['cancer_type', 'lat', 'long', 'keyword', 'trial_status', 'postal_code', 'using_geolocation'].forEach((key) => {
      let pval = params.get('s_' + key);
      if (key == 'lat' || key == 'long' && pval) {
        pval = parseFloat(pval)
      }
      form[key] = params.get('s_' + key) ? pval : null;
    });
    form.trial_status = 'open-to-accural';
    // set default arrays for mutli-selects
    MUTLISELECT_FIELDS.forEach((key) => {
      form[key] = [];
    });
    form.radius = params.get('s_radius') ? radii.filter((a) => a.id == parseInt(params.get('s_radius')))[0] : radii[1];
    return {
      form: form,
      cancer_types: [],
      counties: [],
      therapy_lines: [],
      locations: [],
      radii: radii,
      dropdownHeight: 200,
    }
  },
  methods: {
    getRadiusOptions() {
      return [
        { id: 10, slug: 10, text: "Within 10 miles"},
        { id: 20, slug: 20, text: "Within 20 miles"},
        { id: 50, slug: 50, text: "Within 50 miles"},
        { id: 100, slug: 100, text: "Within 100 miles"},
      ];
    },
    setDropdownValue(form_key, list_key) {
      let params = new URLSearchParams(window.location.search);
      if (params.get('s_' + form_key)) {
        let form_val = params
          .get('s_' + form_key)
          .split(MULTISELECT_DELIMITER)
          .map((a) => { 
            return this[list_key].find((b) => b.value == a );
          });
        if (form_key == 'cancer_type') {
          form_val = form_val[0];
        }
        this.form[form_key] = form_val;
      }
    },
    retrieveDropdowns() {
      Promise.all([
        this.getDropdownValues(window.cancer_types).then((results) =>{
            [...results].forEach((result) => {
              let text = result.text;
              let id = result.id;
              let slug = result.slug;
              let type = {
                text: text,
                value: slug,
                id: id,
                disabled: false,
              };
              this.cancer_types.push(type);
            });
            this.setDropdownValue('cancer_type', 'cancer_types')
        }),
        this.getDropdownValues(window.therapy_lines).then((results) =>{
            [...results].forEach((result) => {
              let text = result.text;
              let id = result.id;
              let slug = result.slug;
              let line = {
                text: text,
                value: slug,
                id: id,
                disabled: false,
              };
              this.therapy_lines.push(line);
            });
            this.setDropdownValue('therapy_line', 'therapy_lines');
        }),
        this.getDropdownValues(window.locations).then((results) =>{
            Object.values(results).forEach(result => {

              let text = result.text
              let id = result.id
              let slug = result.slug;
              let location = {
                text: text,
                value: id,
                id: id,
                disabled: false,
              }
              this.locations.push(location)
            })
            this.setDropdownValue('location_id', 'locations')
        }),
        this.getDropdownValues(window.counties).then((results) =>{
            [...results].forEach((result) => {
              let text = result.text;
              let slug = result.slug;
              let id = result.id;
              let type = {
                text: text,
                value: slug,
                id: id,
                disabled: false
              };
              this.counties.push(type);
            });
            this.setDropdownValue('county', 'counties');
        })
      ]).then(() => {
        if (typeof(this.$parent.type) === 'function' && this.$parent.type() == "ClinicalSearchTemplate") {
          this.searchTrials();
        }
      })
    },
    getDropdownValues(type){
      return new Promise((resolve, reject) => {
        resolve(type)
      })
    },
    getUserLocation() {
      this.form.using_geolocation = !this.form.using_geolocation;
      if (!this.form.using_geolocation) {
        this.form.lat = null;
        this.form.long = null;
      } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.form.lat = position.coords.latitude;
            this.form.long = position.coords.longitude;
          });
          this.form.postal_code = null;
        } else {
          this.form.using_geolocation = false;
        }
      }
    },
    getCancerTypeValues() {
      return this.form.cancer_type ? this.form.cancer_type.value : null;
    },
    getTherapyLineValues() {
      return this.form.therapy_line ? this.form.therapy_line.map((a) => a.value) : null;
    },
    getLocationIdValues() {
      return this.form.location_id ? this.form.location_id.map((a) => a.id) : null;
    },
    getCountyValues() {
      return this.form.county ? this.form.county.map((a) => a.value) : null;
    },
    findReferenceLocation() {
      return new Promise((resolve, reject) => {
        if (this.form.lat) {
          resolve(new google.maps.LatLng({
            lat: this.form.lat,
            lng: this.form.long
          }))
        } else if (this.form.postal_code) {
          geocoder.geocode({ address: this.form.postal_code }, (results, status) => {
            if (status == 'OK') {
              resolve(results[0].geometry.location);
            } else {
              reject("Geocoder status: " + status);
            }
          })
        } else {
          resolve(0);
        }
      });
    },
    searchTrials() {
      if (typeof(this.$parent.type) === 'function' && this.$parent.type() == "ClinicalSearchTemplate") {
        this.findReferenceLocation().then((refLoc) => {
          this.$emit('before-search');
          let lat = null, long = null;
          let radius_dist = 10;
          if (refLoc) {
            lat = refLoc.lat();
            long = refLoc.lng();
          }
          if(this.form.radius){
            radius_dist = this.form.radius.slug
          }
          ApiCalls.getClinicalTrials(this.form.keyword, this.getCancerTypeValues(), this.getTherapyLineValues(), this.getLocationIdValues(), lat, long, this.form.trial_status, this.getCountyValues(), radius_dist).then((data) => {
            if (data != null) {
              this.$emit('search-results', data);
            }
          })
        })
      } else {
        let params = new URLSearchParams();
        for (let key in this.form) {
          if (this.form[key]) {
            let val = this.form[key]
            if (MUTLISELECT_FIELDS.includes(key)) {
              val = val.map((a) => a.value).join(MULTISELECT_DELIMITER)
            } else if (key == 'radius' || key == 'cancer_type') {
              val = val.value;
            }
            params.set('s_' + key, val)
          }
        }
        window.location = "/clinical-trials?" + params.toString();
      }
    },
    resetForm() {
      let form = {};
      for (let key in this.form) {
        form[key] = null;
      }
      // set default arrays for mutli-selects
      MUTLISELECT_FIELDS.forEach((key) => {
        form[key] = [];
      });
      this.form = form;
    },

        findSpacingTarget() {
            return this.$el.closest(".form-container")
        },
        findPositionTop(elem) {
            let offsetTop = 0;
            do {
                offsetTop += elem.offsetTop
            } while (elem = elem.offsetParent)
            return offsetTop;
        },

        onMultiselectOpen(id) {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                let dropdownField = this.$el.querySelector("#" + id).closest('.multiselect')
                let ddtop = this.findPositionTop(dropdownField) - this.findPositionTop(spacingTarget)
                spacingTarget.style.marginBottom = Math.max(0, (ddtop + dropdownField.offsetHeight + this.dropdownHeight) - spacingTarget.offsetHeight) + "px"
            }
        },

        onMultiselectClose() {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                spacingTarget.style.marginBottom = 0
            }
        },
  },
  created() {
    this.retrieveDropdowns()
  },
  mounted() {
    ["search_county", "search_radius", "search_location", "search_cancer_type", "search_therapy_line"].forEach((item) => {
      this.$refs[item].$refs.search.setAttribute("autocomplete", "off");
    })
  }
}
</script>